export default "__VITE_PUBLIC_ASSET__67da7d0a__"